import React from "react";

function FormLineTitle(props) {
  return (
    <div
      className={
        props.color === "1"
          ? "formLineTitle light-grey-form"
          : "formLineTitle grey-form"
      }
    >
      <div className="formLineBlockAll">{props.title}</div>
    </div>
  );
}

export default FormLineTitle;
